import { useRef } from 'react'

const ViewModel = (limitCharacter?: number) => {
	const editorRef = useRef<any>(null)

	const checkCharacterCount = (event: any) => {
		const unprivilegedEditor = editorRef.current?.unprivilegedEditor

		if (limitCharacter && unprivilegedEditor) {
			if (unprivilegedEditor.getLength() > limitCharacter && event.key !== 'Backspace') {
				event.preventDefault()
			}
		}
	}

	const findCharacterLeft = () => {
		const unprivilegedEditor = editorRef.current?.unprivilegedEditor

		if (limitCharacter && unprivilegedEditor) {
			return limitCharacter - unprivilegedEditor.getLength() + 1
		}
	}

	return {
		editorRef,
		checkCharacterCount,
		findCharacterLeft,
	}
}

export default ViewModel
